import { render, staticRenderFns } from "./EditMapCollectionPage.vue?vue&type=template&id=25aa6bfa&"
import script from "./EditMapCollectionPage.vue?vue&type=script&lang=js&"
export * from "./EditMapCollectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports